import { call, ForkEffect, put, takeLatest } from 'redux-saga/effects';
import { IAvalancheData } from 'redux-state/avalanche-advisory/types.js';
import { makeRequest } from 'utilities/fetch/api-gateway.js';
import {
  REDUX_AVALANCHE_ADVISORY_FETCH,
  REDUX_AVALANCHE_ADVISORY_FETCH_ERROR,
  REDUX_AVALANCHE_ADVISORY_FETCH_SUCCESS,
} from './reducer.js';

function* updateWarningsForLocation() {
  try {
    const response: IAvalancheData = yield call(makeRequest, {
      path: `/dynamic/avalanche.json?v=1`,
      apiPrefix: false,
    });

    yield put(REDUX_AVALANCHE_ADVISORY_FETCH_SUCCESS(response));
  } catch (e) {
    console.error('error', e);
    yield put(REDUX_AVALANCHE_ADVISORY_FETCH_ERROR());
  }
}

//https://github.com/Microsoft/TypeScript/issues/2983
export default function* avalancheAdvisorySaga(): IterableIterator<ForkEffect<never>> {
  const fetchAvalanche = REDUX_AVALANCHE_ADVISORY_FETCH();
  yield takeLatest<typeof REDUX_AVALANCHE_ADVISORY_FETCH>(fetchAvalanche.type, updateWarningsForLocation);
}
